import { useTranslation } from "react-i18next"
import { useFeatureFlagEnabled } from "posthog-js/react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"
import { MapPlusIcon, MapPlusIconActive } from "@/components/icons/MapPlusIcon"

const PlanOrderSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const isPlanOrderEnabled = Boolean(useFeatureFlagEnabled("plan-order"))

  if (!isPlanOrderEnabled) return null

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.PLAN_ORDER}
      icon={MapPlusIcon}
      activeIcon={MapPlusIconActive}
      tooltipText={t("app.sidebar.planOrder")}
      className={className}
    />
  )
}

export default PlanOrderSidebarButton
